import Select from "react-select";
import { phoneCode } from "../../helpers/phoneCode";
import { PatternFormat } from "react-number-format";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

const PhoneNumber = ({
  phoneNumberIsValid,
  setPhoneNumber,
  phoneNumber,
  value,
  countryCode,
  setCountryCode,
  isSelectable,
  label,
  required,
}) => {
  const { t } = useTranslation();
  const [storageCountry, setStorageCountry] = useState("");

  useEffect(() => {
    const storageCountryCode = localStorage.getItem("countryCode");
    if (storageCountryCode?.toUpperCase() === "DE") {
      setCountryCode({
        name: "DE +49",
        dial_code: "+49",
        code: "DE",
      });
    } else {
      setCountryCode({
        name: "TR +90",
        dial_code: "+90",
        code: "TR",
      });
    }
    setStorageCountry(storageCountryCode);
    // eslint-disable-next-line
  }, []);

  const changeCountry = (item) => {
    setCountryCode({
      name: item.code + " " + item.dial_code,
      dial_code: item.dial_code,
    });
    setStorageCountry(item.code);
  };
  const customStyles = {
    option: (base, { isFocused, isSelected }) => {
      return {
        ...base,
        backgroundColor: isFocused ? "#f8f8f8" : isSelected ? "#f8f8f8" : "",
        color: isFocused ? "#000" : "#000",
      };
    },
    menu: (base) => ({
      ...base,
      width: "200px",
      minWidth: "100%",
      fontFamily: '"League Regular", sans-serif',
      borderRadius: "none",
    }),
  };
  return (
    <>
      <div className="form-group">
        <label>
          {label}
          {required && <span>*</span>}
        </label>
        <div style={{ display: "flex" }}>
          <div className="select">
            <Select
              isDisabled={isSelectable ? false : true}
              options={phoneCode}
              defaultValue={countryCode}
              value={countryCode}
              isSearchable={false}
              onChange={changeCountry}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.dial_code}
              styles={customStyles}
            />
          </div>
          <PatternFormat
            placeholder={
              storageCountry?.toUpperCase() === "DE"
                ? "_____________"
                : "(5__) ___ __ __"
            }
            className="phone"
            mask="_"
            format={
              storageCountry?.toUpperCase() === "DE"
                ? "###############"
                : "(###) ### ####"
            }
            value={value === undefined ? phoneNumber : value}
            onValueChange={({ floatValue }) => {
              if (floatValue === undefined) {
                floatValue = "";
              }
              const isValid = /^\d{0,15}$/.test(floatValue);
              if (isValid) {
                setPhoneNumber(floatValue);
              }
            }}
          />
        </div>
        {!phoneNumberIsValid && (
          <div className="valid-message">
            {t("auth.phoneNumber.validMessage")}
          </div>
        )}
      </div>
    </>
  );
};

export default PhoneNumber;
